// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumbs_breadcrumb__uKusC","breadcrumb__icon":"Breadcrumbs_breadcrumb__icon__KzC6a","breadcrumbs":"Breadcrumbs_breadcrumbs__ABqGn"};